import styled from 'styled-components';
import { Box } from '@app/src/components/Box';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1 1 auto;

  @media (min-width: 480px) {
    flex-wrap: nowrap;
    flex-direction: row;
  }
`;

export const Content = styled.div`
  width: 100%;
  z-index: 0;

  @media (min-width: 480px) {
    width: calc(100% - 80px);
  }
`;

export const BoxWrapper = styled(Box)`
  padding: 0;
  @media (min-width: 480px) {
    padding: 34px 34px 0;
  }
`;
